import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {
    PROFILE_TYPE_DIRECTOR,
    PROFILE_TYPE_TRANSLATOR,
    PROFILE_TYPE_VOICEACTOR,
    PROFILE_TYPE_SINGER,
    PROFILE_TYPE_ADAPTOR,
    PROFILE_TYPE_LYRICIST,
    PROFILE_TYPE_EDITOR,
    PROFILE_TYPE_SOUNDENGINEER,
    PROFILE_TYPE_BOOKER,

    PERMISSION_VACANCIES_CRITERIA_WRITE
  } from '../../constants'
import Alert from '../../ui-elements/alerts/Alert'
import WithAjax from '../common/helpers/WithAjax'
import WithNotify from '../common/helpers/WithNotify';
import {
  setVacancyCriteriaDropdownOptions,
  fetchVacancySkillVendorsByCriteriaSuccess,
  clearVacancySkillVendorsByCriteria,
  clearVacancyCandidates,
  setVacancyCriteriaCheckboxValue
} from '../../actions/pages/vacancy-page'
import DirectorCriteria from './criteria-content/profile/DirectorCriteria'
import TranslatorCriteria from './criteria-content/profile/TranslatorCriteria'
import VoiceActorCriteria from './criteria-content/profile/VoiceActorCriteria'
import SingerCriteria from './criteria-content/profile/SingerCriteria'
import AdaptorCriteria from './criteria-content/profile/AdaptorCriteria'
import LyricistCriteria from './criteria-content/profile/LyricistCriteria'
import EditorCriteria from './criteria-content/profile/EditorCriteria'
import SoundEngineerCriteria from './criteria-content/profile/SoundEngineerCriteria'
import BookerCriteria from './criteria-content/profile/BookerCriteria'
import CriteriaResult from './criteria-content/CriteriaResult'
import ProtectedElement from '../common/helpers/ProtectedElement'

class Criteria extends Component {
  constructor() {
    super()
    this.enableCriteria = this.enableCriteria.bind(this)



    this.state = {
      url: null,
      criteriaEnabled: null,
      dataSearch: '',
      nativeLanguageSelectedValue:'',
      additionalLanguagesSelectedValue:'',
      countrySelectedValue:'',
      citySelectedValue:'',
      regionSelectedValue:'',
      ethnicitySelectedValue:'',
      ethnicityExists:false,
      identitySelectedValue: '',
      identityExists:false,
      skillLevelSelectedValue: '',
      skillTypeSelectedValue: '',
      ageFromSelectedValue:'',
      ageToSelectedValue:'',
      doNotUseSelectedValue:'',
      knownTalentSelectedValue:'',
      skillVendorStatusSelectedValue:'',
      voiceAgeSelectedValue:'',
      voiceTypeSelectedValue:'',
      liveActionVoiceGenderMale:'',
      liveActionVoiceGenderFemale:'',
      voiceActorAnimationMaleVoiceGender:'',
      voiceActorTheatricalExperience:'',
      voiceActorTVExperience:'',
      voiceActorVideoGamesExperience:'',
      voiceActorPromoOrCommercialsExperience:'',
      voiceActorLiveActionExperience:'',
      voiceActorAnimationExperience:'',
      voiceActorDubbingExperience:'',
      voiceActorAudiobooksExperience:'',
      voiceActorVoiceOverExperience:'',
      voiceActorRadioExperience:'',
      voiceActorTheatreActorExperience:'',
      voiceActorMovieActorExperience:'',
      voiceActorAudioDescriptionExperience:'',
      voiceActorStudio:'',
      voiceActorClient:'',
      voiceActorUnionSelectedValue:'',
      isVoiceActorUnion:false,
      voiceActorSchool:'',
      voiceActorGenderNeutralVoice:'',
      languageAccent:'',
      productionCast:'',
      externalExperienceCast:'',
      vacancyCast:'',
      remoteRecordingListVoiceActorSelectedValue:'',
      bookerTheatricalExperience:'',
      bookerTVExperience:'',
      bookerInteractiveExperience:'',
      bookerStudio:'',
      directorTheatricalExperience:'',
      directorTVExperience:'',
      directorVideoGamesExperience:'',
      directorPromoCommercialsExperience:'',
      directorLiveActionExperience:'',
      directorAnimationExperience:'',
      directorDubbingDirectorExperience:'',
      directorVoiceOverDirectorExperience:'',
      directorSongDirectorExperience:'',
      directorDubbingActorExperience:'',
      directorStageDirectorExperience:'',
      directorMovieDirectorExperience:'',
      directorAudioDescriptionExperience:'',
      directorStudio:'',
      directorClient:'',
      directorSchool:'',
      remoteRecordingDirectorSelectedValue:'',
      directorAppAccess:'',
      lyricistMusicalExperience:'',
      lyricistTheatreExperience:'',
      lyricistPromoCommercialsExperience:'',
      lyricistExperience:'',
      lyricistDubbingExperience:'',
      lyricistMusicianExperience:'',
      lyricistNumberOfSongsWritten:'',
      lyricistUniversityDegree:'',
      lyricistStudio:'',
      lyricistClient:'',
      remoteRecordingLyricistSelectedValue:'',
      singerMaleVoiceGender:'',
      singerFemaleVoiceGender:'',
      voiceAgeSingerSelectedValue: '',
      vocalRangeSingerSelectedValue: '',
      readingMusicNoteSingerSelectedValue: '',
      singerDubbingExperience:'',
      singerStageExperience:'',
      singerTheatreExperience:'',
      singerTalentShowExperience:'',
      singerStudio:'',
      singerClient:'',
      singerSchool:'',
      remoteRecordingSingerSelectedValue:'',
      singerUnionSelectedValue:'',
      isSingerUnion:false,
      singerGenderNeutralVoice:'',
      translatorTheatricalExperience:'',
      translatorTVExperience:'',
      translatorGamesExperience:'',
      translatorPromoOrCommercialsExperience:'',
      translatorLiveActionExperience:'',
      translatorAnimationExperience:'',
      translatorSubtitlesExperience:'',
      translatorDubbingExperience:'',
      translatorVoiceOverExperience:'',
      translatorGamingExperience:'',
      translatorAudioDescriptionExperience:'',
      translatorHOHSDHCCExperience:'',
      translatorNumberOfTranslations:'',
      translatorUniversityDegree:'',
      translatorStudios:'',
      translatorClients:'',
      editorDubbingExperience:'',
      editorVoiceOverExperience:'',
      editorSongsExperience:'',
      editorProToolsExperience:'',
      editorDolby51Experience:'',
      editorAtmosExperience:'',
      editorFoleyExperience:'',
      editorRecordingEditingExperience:'',
      editorDialogueEditingExperience:'',
      editorMusicAndEffectsExperience:'',
      editorMixEditingExperience:'',
      editorPreparingTakesExperience:'',
      editorAudioDescriptionExperience:'',
      editorStudios:'',
      editorClients:'',
      editorSchools:'',
      editorRemoteRecordingCapability:'',
      adaptorTheatricalExperience:'',
      adaptorTVExperience:'',
      adaptorGamesExperience:'',
      adaptorPromoOrCommercialsExperience:'',
      adaptorLiveActionExperience:'',
      adaptorAnimationExperience:'',
      adaptorAdaptorExperience:'',
      adaptorDubbingDirectorExperience:'',
      adaptorTranslatorExperience:'',
      adaptorVoiceActorExperience:'',
      adaptorAudioDescriptionExperience:'',
      adaptorNumberOfAdaptionsRange:'',
      adaptorUniversityDegree:'',
      adaptorStudios:'',
      adaptorClients:'',
      soundEngineerDubbingExperience:'',
      soundEngineerVoiceOverExperience:'',
      soundEngineerSongsExperience:'',
      soundEngineerProToolsExperience:'',
      soundEngineerDolby51Experience:'',
      soundEngineerAtmosExperience:'',
      soundEngineerFoleyExperience:'',
      soundEngineerDialogueRecordingExperience:'',
      soundEngineerSongRecordingExperience:'',
      soundEngineerDialogueMixingExperience:'',
      soundEngineerSongMixingExperience:'',
      soundEngineerAudioDescriptionMixingExperience:'',
      soundEngineerStudios:'',
      soundEngineerClients:'',
      soundEngineerSchools:'',
      soundEngineerRemoteRecordingCapability:'',
      candidatesMatchingEnabled:false,
      isCriteriaDataSet: false,
      dataResult:[],
      adaptorDoNotUse:'',
      bookerDoNotUse:'',
      directorDoNotUse:'',
      editorDoNotUse:'',
      lyricistDoNotUse:'',
      singerDoNotUse:'',
      soundEngineerDoNotUse:'',
      tanslatorDoNotUse:'',
      voiceActorDoNotUse:''

    }
  }


  componentDidMount() {

    //get current criteria
    let url2 = 'vacancies/' + this.props.vacancyId + '/getCurrentCriteria';
    this.props.ajax.get(url2, true, (data) => {
      //candidatesMatchingEnabled
      this.setState({candidatesMatchingEnabled:data.CandidatesMatchingEnabled})

      if(data.Items.length > 0){
        data.Items.map((criteria) => {
          //age from criteria
          if(criteria.SearchProperty == 3){
            let values = criteria.Values;

            let ageFromSelected = values[0].toString();
            this.setState({ageFromSelectedValue: ageFromSelected});

            let ageEndSelected = values.pop().toString();;

            this.setState({ageToSelectedValue: ageEndSelected});

          }

          //native language criteria
          if(criteria.SearchProperty == 9){
            let values = criteria.Values.toString();
            this.setState({nativeLanguageSelectedValue: values});
          }

          //additional language criteria
          if(criteria.SearchProperty == 10){
            let values = criteria.Values.toString();
            this.setState({additionalLanguagesSelectedValue: values});
          }

          //country criteria
          if(criteria.SearchProperty == 6){
            let values = criteria.Values.toString();
            this.setState({countrySelectedValue: values});
          }

          //city criteria
          if(criteria.SearchProperty == 7){
            let values = criteria.Values.toString();
            this.setState({citySelectedValue: values});
          }

          //region criteria
          if(criteria.SearchProperty == 16){
            let values = criteria.Values.toString();
            this.setState({regionSelectedValue: values});
          }

          //ethnicity criteria
          if(criteria.SearchProperty == 13){
            let values = criteria.Values.toString();
            this.setState({ethnicitySelectedValue: values});
          }

          //identity criteria
          if(criteria.SearchProperty == 14){
            let values = criteria.Values.toString();
            this.setState({identitySelectedValue: values});
          }

          //skillLevel criteria
          if(criteria.SearchProperty == 22){
            let values = criteria.Values.toString();
            this.setState({skillLevelSelectedValue: values});
          }

          //skillType criteria
          if(criteria.SearchProperty == 20){
            let values = criteria.Values.toString();
            this.setState({skillTypeSelectedValue: values})
          }


          //voiceAge criteria voiceActor
          if(criteria.SearchProperty == 2821){
            let values = criteria.Values.toString();
            this.setState({voiceAgeSelectedValue: values});
          }

          //voiceAge criteria singer
          if(criteria.SearchProperty == 2507){
            let values = criteria.Values.toString();
            this.setState({voiceAgeSelectedValue: values});
          }

          //voiceType criteria voiceActor
          if(criteria.SearchProperty == 2823){
            let values = criteria.Values.toString();
            this.setState({voiceTypeSelectedValue: values});
          }

          //doNotUse criteria
          if(criteria.SearchProperty == 4){
            this.setState({doNotUseSelectedValue: true});
          }

          //knownTalent criteria
          if(criteria.SearchProperty == 24){
            this.setState({knownTalentSelectedValue: true});
          }

          //skillVendorStatus criteria
          if(criteria.SearchProperty == 5){
            this.setState({skillVendorStatusSelectedValue: true});
          }

          //voice gender male live action criteria voiceActor
          if(criteria.SearchProperty == 2815){
            this.setState({liveActionVoiceGenderMale:true});
          }

          //voice gender female live action criteria voiceActor
          if(criteria.SearchProperty == 2816){
            this.setState({liveActionVoiceGenderFemale:true});
          }

          //voiceActorAnimationMaleVoiceGender
          if(criteria.SearchProperty == 2817){
            this.setState({voiceActorAnimationMaleVoiceGender:true});
          }

          //voiceActorAnimationFemaleVoiceGender
          if(criteria.SearchProperty == 2818){
            this.setState({voiceActorAnimationFemaleVoiceGender:true});
          }

          //VoiceActorTheatricalExperience
          if(criteria.SearchProperty == 2808){
            this.setState({voiceActorTheatricalExperience:true});
          }

          //VoiceActorTVExperience
          if(criteria.SearchProperty == 2809){
            this.setState({voiceActorTVExperience:true});
          }

          //voiceActorVideoGamesExperience
          if(criteria.SearchProperty == 2810){
            this.setState({voiceActorVideoGamesExperience:true});
          }

          //voiceActorPromoOrCommercialsExperience
          if(criteria.SearchProperty == 2811){
            this.setState({voiceActorPromoOrCommercialsExperience:true});
          }

          //voiceActorLiveActionExperience
          if(criteria.SearchProperty == 2812){
            this.setState({voiceActorLiveActionExperience:true});
          }

          //voiceActorAnimationExperience
          if(criteria.SearchProperty == 2813){
            this.setState({voiceActorAnimationExperience:true});
          }

          //voiceActorDubbingExperience
          if(criteria.SearchProperty == 2801){
            this.setState({voiceActorDubbingExperience:true});
          }

          //voiceActorAudiobooksExperience
          if(criteria.SearchProperty == 2802){
            this.setState({voiceActorAudiobooksExperience:true});
          }

          //voiceActorVoiceOverExperience
          if(criteria.SearchProperty == 2803){
            this.setState({voiceActorVoiceOverExperience:true});
          }

          //voiceActorRadioExperience
          if(criteria.SearchProperty == 2804){
            this.setState({voiceActorRadioExperience:true});
          }

          //voiceActorTheatreActorExperience
          if(criteria.SearchProperty == 2805){
            this.setState({voiceActorTheatreActorExperience:true});
          }

          //voiceActorMovieActorExperience
          if(criteria.SearchProperty == 2806){
            this.setState({voiceActorMovieActorExperience:true});
          }

          //voiceActorAudioDescriptionExperience
          if(criteria.SearchProperty == 2807){
            this.setState({voiceActorAudioDescriptionExperience:true});
          }


          //voiceactor studio
          if(criteria.SearchProperty == 2819){
            let values = criteria.Values.toString();
            this.setState({voiceActorStudio:values});
          }

          //voiceactor client
          if(criteria.SearchProperty == 2820){
            let values = criteria.Values.toString();
            this.setState({voiceActorClient:values});
          }

          //voiceactor school
          if(criteria.SearchProperty == 2826){
            let values = criteria.Values.toString();
            this.setState({voiceActorSchool:values});
          }

          //voiceactor languageAccent
          if(criteria.SearchProperty == 2822){
            let values = criteria.Values.toString();
            this.setState({languageAccent:values});
          }

          //voiceactor remoteRecording
          if(criteria.SearchProperty == 2814){
            let values = criteria.Values.toString();
            this.setState({remoteRecordingListVoiceActorSelectedValue:values});
          }

          //voiceactor union
          if(criteria.SearchProperty == 2824){
            let values = criteria.Values.toString();
            this.setState({voiceActorUnionSelectedValue:values});
          }

          //voiceActorGenderNeutralVoice
          if(criteria.SearchProperty == 2825){
            this.setState({voiceActorGenderNeutralVoice:true});
          }

          //peoduction cast
          if(criteria.SearchProperty == 17){
            let values = criteria.Values.toString();
            this.setState({productionCast:values});
          }

          //externalExperience cast
          if(criteria.SearchProperty == 19){
            let values = criteria.Values.toString();
            this.setState({externalExperienceCast:values});
          }

          //vacancy cast
          if(criteria.SearchProperty == 18){
            let values = criteria.Values.toString();
            this.setState({vacancyCast:values});
          }

          //booker theatrical
          if(criteria.SearchProperty == 2101){
            this.setState({bookerTheatricalExperience:true});
          }

          //booker tv
          if(criteria.SearchProperty == 2102){
            this.setState({bookerTVExperience:true});
          }

          //booker interactive
          if(criteria.SearchProperty == 2103){
            this.setState({bookerInteractiveExperience:true});
          }

          //booker studio
          if(criteria.SearchProperty == 2104){
            let values = criteria.Values.toString();
            this.setState({bookerStudio:values});
          }

          //director dubbing director
          if(criteria.SearchProperty == 2201){
            this.setState({directorDubbingDirectorExperience:true});
          }

          //director v/o director
          if(criteria.SearchProperty == 2202){
            this.setState({directorVoiceOverDirectorExperience:true});
          }

          //director song director
          if(criteria.SearchProperty == 2203){
            this.setState({directorSongDirectorExperience:true});
          }

          //director dubbing director
          if(criteria.SearchProperty == 2204){
            this.setState({directorDubbingActorExperience:true});
          }

          //director stage director
          if(criteria.SearchProperty == 2205){
            this.setState({directorStageDirectorExperience:true});
          }

          //director movie director experience
          if(criteria.SearchProperty == 2206){
            this.setState({directorMovieDirectorExperience:true});
          }

          //director theatrical experience
          if(criteria.SearchProperty == 2207){
            this.setState({directorTheatricalExperience:true});
          }

          //director tv experience
          if(criteria.SearchProperty == 2208){
            this.setState({directorTVExperience:true});
          }

          //director games experience
          if(criteria.SearchProperty == 2209){
            this.setState({directorGamesExperience:true});
          }

          //director promo Commercials experience
          if(criteria.SearchProperty == 2210){
            this.setState({directorPromoOrCommercialsExperience:true});
          }

          //director live action  experience
          if(criteria.SearchProperty == 2211){
            this.setState({directorLiveActionExperience:true});
          }

          //director  animation  experience
          if(criteria.SearchProperty == 2212){
            this.setState({directorAnimationExperience:true});
          }

          //director  audio description  experience
          if(criteria.SearchProperty == 2213){
            this.setState({directorAudioDescriptionExperience:true});
          }

          //director  directorRemoteRecording
          if(criteria.SearchProperty == 2214){
            let values = criteria.Values.toString()
            this.setState({remoteRecordingDirectorSelectedValue:values});
          }

          //director  app access
          if(criteria.SearchProperty == 2215){
            let values = criteria.Values.toString();
            this.setState({directorAppAccess:values});
          }

          //director  studio
          if(criteria.SearchProperty == 2216){
            let values = criteria.Values.toString();
            this.setState({directorStudio:values});
          }

          //director  client
          if(criteria.SearchProperty == 2217){
            let values = criteria.Values.toString();
            this.setState({directorClient:values});
          }

          //director school
          if(criteria.SearchProperty == 2218){
            let values = criteria.Values.toString();
            this.setState({directorSchool:values});
          }

          //singer singerMaleVoiceGender
          if(criteria.SearchProperty == 2509){
            this.setState({singerMaleVoiceGender:true});
          }

          //singer singerFemaleVoiceGender
          if(criteria.SearchProperty == 2510){
            this.setState({singerFemaleVoiceGender:true});
          }

          //singer vocalRangeSingerSelectedValue
          if(criteria.SearchProperty == 2506){
            let values = criteria.Values.toString();
            this.setState({vocalRangeSingerSelectedValue:values});
          }

          //singer voiceAgeSingerSelectedValue
          if(criteria.SearchProperty == 2508){
            let values = criteria.Values.toString();
            this.setState({voiceAgeSingerSelectedValue:values});
          }

          //singer readingMusicNoteSingerSelectedValue
          if(criteria.SearchProperty == 2507){
            let values = criteria.Values.toString();
            this.setState({readingMusicNoteSingerSelectedValue:values});
          }


          //singer singerDubbingExperience
          if(criteria.SearchProperty == 2501){
            this.setState({singerDubbingExperience:true});
          }

          //singer singerStageExperience
          if(criteria.SearchProperty == 2502){
            this.setState({singerStageExperience:true});
          }

          //singer singerTheatreExperience
          if(criteria.SearchProperty == 2503){
            this.setState({singerTheatreExperience:true});
          }

          //singer singerTalentShowExperience
          if(criteria.SearchProperty == 2505){
            this.setState({singerTalentShowExperience:true});
          }

          //singer studio
          if(criteria.SearchProperty == 2511){
            let values = criteria.Values.toString();
            this.setState({singerStudio:values});
          }

          //singer client
          if(criteria.SearchProperty == 2512){
            let values = criteria.Values.toString();
            this.setState({singerClient:values});
          }

          //singer school
          if(criteria.SearchProperty == 2515){
            let values = criteria.Values.toString();
            this.setState({singerSchool:values});
          }

          //singer remoteRecording
          if(criteria.SearchProperty == 2504){
            let values = criteria.Values.toString();
            this.setState({remoteRecordingSingerSelectedValue:values});
          }

          //singer union
          if(criteria.SearchProperty == 2513){
            let values = criteria.Values.toString();
            this.setState({singerUnionSelectedValue:values});
          }

          //singerGenderNeutralVoice
          if(criteria.SearchProperty == 2514){
            this.setState({singerGenderNeutralVoice:true});
          }

          //lyricistMusicalExperience
          if(criteria.SearchProperty == 2406){
            this.setState({lyricistMusicalExperience:true});
          }

          //lyricistTheatreExperience
          if(criteria.SearchProperty == 2407){
            this.setState({lyricistTheatreExperience:true});
          }

          //lyricistPromoCommercialsExperience
          if(criteria.SearchProperty == 2408){
            this.setState({lyricistPromoCommercialsExperience:true});
          }

          //lyricistExperience
          if(criteria.SearchProperty == 2401){
            this.setState({lyricistExperience:true});
          }

          //lyricistDubbingExperience
          if(criteria.SearchProperty == 2402){
            this.setState({lyricistDubbingExperience:true});
          }

          //lyricistMusicianExperience
          if(criteria.SearchProperty == 2403){
            this.setState({lyricistMusicianExperience:true});
          }

          //lyricistNumberOfSongsWritten
          if(criteria.SearchProperty == 2404){
            let values = criteria.Values.toString();
            this.setState({lyricistNumberOfSongsWritten:values});
          }

          //lyricistUniversityDegree
          if(criteria.SearchProperty == 2409){
            let values = criteria.Values.toString();
            this.setState({lyricistUniversityDegree:values});
          }

          //lyricistStudio
          if(criteria.SearchProperty == 2410){
            let values = criteria.Values.toString();
            this.setState({lyricistStudio:values});
          }

          //lyricistClient
          if(criteria.SearchProperty == 2411){
            let values = criteria.Values.toString();
            this.setState({lyricistClient:values});
          }

          //lyricist remoteRecording
          if(criteria.SearchProperty == 2405){
            let values = criteria.Values.toString();
            this.setState({remoteRecordingLyricistSelectedValue:values});
          }

          //translatorTheatricalExperience
          if(criteria.SearchProperty == 2709){
            this.setState({translatorTheatricalExperience:true});
          }

          //translatorTVExperience
          if(criteria.SearchProperty == 2710){
            this.setState({translatorTVExperience:true});
          }

          //translatorGamesExperience
          if(criteria.SearchProperty == 2711){
            this.setState({translatorGamesExperience:true});
          }

          //translatorPromoOrCommercialsExperience
          if(criteria.SearchProperty == 2712){
            this.setState({translatorPromoOrCommercialsExperience:true});
          }

          //translatorLiveActionExperience
          if(criteria.SearchProperty == 2713){
            this.setState({translatorLiveActionExperience:true});
          }

          //translatorAnimationExperience
          if(criteria.SearchProperty == 2714){
            this.setState({translatorAnimationExperience:true});
          }

          //translatorSubtitlesExperience
          if(criteria.SearchProperty == 2701){
            this.setState({translatorSubtitlesExperience:true});
          }

          //translatorDubbingExperience
          if(criteria.SearchProperty == 2702){
            this.setState({translatorDubbingExperience:true});
          }

          //translatorVoiceOverExperience
          if(criteria.SearchProperty == 2703){
            this.setState({translatorVoiceOverExperience:true});
          }

          //translatorGamingExperience
          if(criteria.SearchProperty == 2704){
            this.setState({translatorGamingExperience:true});
          }


          //translatorAudioDescriptionExperience
          if(criteria.SearchProperty == 2705){
            this.setState({translatorAudioDescriptionExperience:true});
          }

          //translatorHOHSDHCCExperience
          if(criteria.SearchProperty == 2706){
            this.setState({translatorHOHSDHCCExperience:true});
          }

          //translatorNumberOfTranslations
          if(criteria.SearchProperty == 2708){
            let values = criteria.Values.toString();
            this.setState({translatorNumberOfTranslations:values});
          }

          //translatorUniversityDegree
          if(criteria.SearchProperty == 2715){
            let values = criteria.Values.toString();
            this.setState({translatorUniversityDegree:values});
          }

          //translatorStudios
          if(criteria.SearchProperty == 2716){
            let values = criteria.Values.toString();
            this.setState({translatorStudios:values});
          }

          //translatorClients
          if(criteria.SearchProperty == 2717){
            let values = criteria.Values.toString();
            this.setState({translatorClients:values});
          }


          //editorDubbingExperience
          if(criteria.SearchProperty == 2306){
            this.setState({editorDubbingExperience:true});
          }

          //editorVoiceOverExperience
          if(criteria.SearchProperty == 2307){
            this.setState({editorVoiceOverExperience:true});
          }

          //editorSongsExperience
          if(criteria.SearchProperty == 2308){
            this.setState({editorSongsExperience:true});
          }

          //editorProToolsExperience
          if(criteria.SearchProperty == 2309){
            this.setState({editorProToolsExperience:true});
          }

          //editorDolby51Experience
          if(criteria.SearchProperty == 2310){
            this.setState({editorDolby51Experience:true});
          }

          //editorAtmosExperience
          if(criteria.SearchProperty == 2311){
            this.setState({editorAtmosExperience:true});
          }

          //editorFoleyExperience
          if(criteria.SearchProperty == 2312){
            this.setState({editorFoleyExperience:true});
          }

          //editorRecordingEditingExperience
          if(criteria.SearchProperty == 2301){
            this.setState({editorRecordingEditingExperience:true});
          }

          //editorDialogueEditingExperience
          if(criteria.SearchProperty == 2302){
            this.setState({editorDialogueEditingExperience:true});
          }

          //editorMusicAndEffectsExperience
          if(criteria.SearchProperty == 2303){
            this.setState({editorMusicAndEffectsExperience:true});
          }

          //editorMixEditingExperience
          if(criteria.SearchProperty == 2304){
            this.setState({editorMixEditingExperience:true});
          }

          //editorPreparingTakesExperience
          if(criteria.SearchProperty == 2305){
            this.setState({editorPreparingTakesExperience:true});
          }

          //editorAudioDescriptionExperience
          if(criteria.SearchProperty == 2313){
            this.setState({editorAudioDescriptionExperience:true});
          }

          //editorStudios
          if(criteria.SearchProperty == 2315){
            let values = criteria.Values.toString();
            this.setState({editorStudios:values});
          }

          //editorClients
          if(criteria.SearchProperty == 2316){
            let values = criteria.Values.toString();
            this.setState({editorClients:values});
          }

          //editorSchools
          if(criteria.SearchProperty == 2317){
            let values = criteria.Values.toString();
            this.setState({editorSchools:values});
          }

          //editorRemoteRecording
          if(criteria.SearchProperty == 2314){
            let values = criteria.Values.toString();
            this.setState({editorRemoteRecordingCapability:values});
          }



          //adaptorTheatricalExperience
          if(criteria.SearchProperty == 2005){
            this.setState({adaptorTheatricalExperience:true});
          }

          //adaptorTVExperience
          if(criteria.SearchProperty == 2006){
            this.setState({adaptorTVExperience:true});
          }

          //adaptorGamesExperience
          if(criteria.SearchProperty == 2007){
            this.setState({adaptorGamesExperience:true});
          }

          //adaptorPromoOrCommercialsExperience
          if(criteria.SearchProperty == 2008){
            this.setState({adaptorPromoOrCommercialsExperience:true});
          }

          //adaptorLiveActionExperience
          if(criteria.SearchProperty == 2009){
            this.setState({adaptorLiveActionExperience:true});
          }

          //adaptorAnimationExperience
          if(criteria.SearchProperty == 2010){
            this.setState({adaptorAnimationExperience:true});
          }

          //adaptorAdaptorExperience
          if(criteria.SearchProperty == 2001){
            this.setState({adaptorAdaptorExperience:true});
          }

          //adaptorDubbingDirectorExperience
          if(criteria.SearchProperty == 2002){
            this.setState({adaptorDubbingDirectorExperience:true});
          }

          //adaptorTranslatorExperience
          if(criteria.SearchProperty == 2003){
            this.setState({adaptorTranslatorExperience:true});
          }

          //adaptorVoiceActorExperience
          if(criteria.SearchProperty == 2004){
            this.setState({adaptorVoiceActorExperience:true});
          }

          //adaptorAudioDescriptionExperience
          if(criteria.SearchProperty == 2011){
            this.setState({adaptorAudioDescriptionExperience:true});
          }

          //adaptorNumberOfAdaptionsRange
          if(criteria.SearchProperty == 2012){
            let values = criteria.Values.toString();
            this.setState({adaptorNumberOfAdaptionsRange:values});
          }

          //adaptorUniversityDegree
          if(criteria.SearchProperty == 2013){
            let values = criteria.Values.toString();
            this.setState({adaptorUniversityDegree:values});
          }

          //adaptorStudios
          if(criteria.SearchProperty == 2014){
            let values = criteria.Values.toString();
            this.setState({adaptorStudios:values});
          }

          //adaptorClients
          if(criteria.SearchProperty == 2015){
            let values = criteria.Values.toString();
            this.setState({adaptorClients:values});
          }

          //soundEngineerDubbingExperience
          if(criteria.SearchProperty == 2607){
            this.setState({soundEngineerDubbingExperience:true});
          }

          //soundEngineerVoiceOverExperience
          if(criteria.SearchProperty == 2608){
            this.setState({soundEngineerVoiceOverExperience:true});
          }

          //soundEngineerSongsExperience
          if(criteria.SearchProperty == 2609){
            this.setState({soundEngineerSongsExperience:true});
          }

          //soundEngineerProToolsExperience
          if(criteria.SearchProperty == 2610){
            this.setState({soundEngineerProToolsExperience:true});
          }

          //soundEngineerDolby51Experience
          if(criteria.SearchProperty == 2611){
            this.setState({soundEngineerDolby51Experience:true});
          }

          //soundEngineerAtmosExperience
          if(criteria.SearchProperty == 2612){
            this.setState({soundEngineerAtmosExperience:true});
          }

          //soundEngineerFoleyExperience
          if(criteria.SearchProperty == 2613){
            this.setState({soundEngineerFoleyExperience:true});
          }

          //soundEngineerDialogueRecordingExperience
          if(criteria.SearchProperty == 2601){
            this.setState({soundEngineerDialogueRecordingExperience:true});
          }

          //soundEngineerSongRecordingExperience
          if(criteria.SearchProperty == 2602){
            this.setState({soundEngineerSongRecordingExperience:true});
          }

          //soundEngineerDialogueMixingExperience
          if(criteria.SearchProperty == 2603){
            this.setState({soundEngineerDialogueMixingExperience:true});
          }


          //soundEngineerSongMixingExperience
          if(criteria.SearchProperty == 2604){
            this.setState({soundEngineerSongMixingExperience:true});
          }

          //soundEngineerAudioDescriptionMixingExperience
          if(criteria.SearchProperty == 2605){
            this.setState({soundEngineerAudioDescriptionMixingExperience:true});
          }

          //soundEngineerStudios
          if(criteria.SearchProperty == 2614){
            let values = criteria.Values.toString();
            this.setState({soundEngineerStudios:values});
          }

          //soundEngineerClients
          if(criteria.SearchProperty == 2615){
            let values = criteria.Values.toString();
            this.setState({soundEngineerClients:values});
          }

          //soundEngineerSchools
          if(criteria.SearchProperty == 2616){
            let values = criteria.Values.toString();
            this.setState({soundEngineerSchools:values});
          }

          //soundEngineerRemoteRecordingCapability
          if(criteria.SearchProperty == 2606){
            let values = criteria.Values.toString();
            this.setState({soundEngineerRemoteRecordingCapability:values});
          }

          //adaptorDoNotUse
          if(criteria.SearchProperty == 2017){
            this.setState({adaptorDoNotUse:true});
          }

          //bookerDoNotUse
          if(criteria.SearchProperty == 2107){
            this.setState({bookerDoNotUse:true});
          }

          //directorDoNotUse
          if(criteria.SearchProperty == 2219){
            this.setState({directorDoNotUse:true});
          }

          //editorDoNotUse
          if(criteria.SearchProperty == 2318){
            this.setState({editorDoNotUse:true});
          }

          //lyricistDoNotUse
          if(criteria.SearchProperty == 2413){
            this.setState({lyricistDoNotUse:true});
          }

          //singerDoNotUse
          if(criteria.SearchProperty == 2516){
            this.setState({singerDoNotUse:true});
          }

          //soundEngineerDoNotUse
          if(criteria.SearchProperty == 2617){
            this.setState({soundEngineerDoNotUse:true});
          }

          //translatorDoNotUse
          if(criteria.SearchProperty == 2719){
            this.setState({translatorDoNotUse:true});
          }

          //voiceActorDoNotUse
          if(criteria.SearchProperty == 2827){
            console.log('okk');
            this.setState({voiceActorDoNotUse:true});
          }




        })
      }
    });

    //set dropdown options
    let url = 'skillVendors/searchpage';
    this.props.ajax.get(url, true, (data) => {

      //experience new object
      var experienceList = {Items: [], SelectedValue: this.state.additionalLanguagesSelectedValue};
      var experienceObj = data.Experiences.Items;
      for (var i = 0; i < experienceObj.length; i++){
        experienceList.Items.push({ value:experienceObj[i].id , label:experienceObj[i].label  });
      }

      //nativeLanguage new object
      var nativeLanguageList = {Items: [], SelectedValue: this.state.nativeLanguageSelectedValue};
      var nativeLanguageObj = data.NativeLanguages.Items;
      for (var i = 0; i < nativeLanguageObj.length; i++){
        nativeLanguageList.Items.push({ value:nativeLanguageObj[i].id , label:nativeLanguageObj[i].label  });
      }

      //country new object
      var countryList = {Items: [], SelectedValue: this.state.countrySelectedValue};
      var countryObj = data.CountriesOfLiving.Items;
      for (var i = 0; i < countryObj.length; i++){
        countryList.Items.push({ value:countryObj[i].id , label:countryObj[i].label  });
      }

      //city new object
      var cityList = {Items: [], SelectedValue: this.state.citySelectedValue};
      var cityObj = data.Cities.Items;
      for (var i = 0; i < cityObj.length; i++){
        cityList.Items.push({ value:cityObj[i].id , label:cityObj[i].label  });
      }

      //region new object
      var regionList = {Items: [], SelectedValue: this.state.regionSelectedValue};
      if(data.Regions.Items.length>0){
        this.setState({isRegions: true});
        var regionObj = data.Regions.Items;
        for (var i = 0; i < regionObj.length; i++){
          regionList.Items.push({ value:regionObj[i].id , label:regionObj[i].label  });
        }
      }

      //ethnicity new object
      var ethnicityList = {Items: [], SelectedValue: this.state.ethnicitySelectedValue};
      if(data.Ethnicities.Items.length>0){
        this.setState({isEthnicity: true});
        var ethnicityObj = data.Ethnicities.Items;
        for (var i = 0; i < ethnicityObj.length; i++){
          ethnicityList.Items.push({ value:ethnicityObj[i].id , label:ethnicityObj[i].label  });
        }
        this.setState({ethnicityExists:true});
      }

      //identity new object
      var identityList = {Items: [], SelectedValue: this.state.identitySelectedValue};
      if(data.Identities.Items.length>0){
        this.setState({isIdentity: true});
        var identityObj = data.Identities.Items;
        for (var i = 0; i < identityObj.length; i++){
          identityList.Items.push({ value:identityObj[i].id , label:identityObj[i].label  });
        }
        this.setState({identityExists:true});
      }

      //skillLevel new object
      var skillLevelList = {Items: [], SelectedValue: this.state.skillLevelSelectedValue};
      var skillLevelObj = data.SkillLevels.Items;
      for (var i = 0; i < skillLevelObj.length; i++){
        skillLevelList.Items.push({ value:skillLevelObj[i].id , label:skillLevelObj[i].label  });
      }

      //skillType new object
      var skillTypeList = {Items: [], SelectedValue: this.state.skillTypeSelectedValue};
      var skillTypeObj = data.SkillTypes.Items;
      for (var i = 0; i < skillTypeObj.length; i++){
        if(skillTypeObj[i].id == 0){
          var idsArr = [];
          for (var j = 0; j < skillTypeObj[i].Children.length; j++){
            idsArr.push(skillTypeObj[i].Children[j].id)
          }
          skillTypeList.Items.push({ value:idsArr , label:skillTypeObj[i].label  });
        }else{
            skillTypeList.Items.push({ value:skillTypeObj[i].id , label:skillTypeObj[i].label});
        }
      }
      //age from list
      var ageFromList = {Items: [], SelectedValue: this.state.ageFromSelectedValue};
      for (var i = 1; i < 101; i++){
        ageFromList.Items.push({ value: i, label: i.toString() });
      }


      //age to list
      var ageToList = {Items: [], SelectedValue: this.state.ageToSelectedValue};
      for (var i = 1; i < 101; i++){
        ageToList.Items.push({ value: i, label: i.toString() });
      }


      //VoiceAgeRange new object
      var voiceAgeRangeList = {Items: [], SelectedValue: this.state.voiceAgeSelectedValue};
      var oiceAgeRangeObj = data.VoiceAgeRanges.Items;
      for (var i = 0; i < oiceAgeRangeObj.length; i++){
        voiceAgeRangeList.Items.push({ value:oiceAgeRangeObj[i].id , label:oiceAgeRangeObj[i].label  });
      }

      //voiceType new object
      var voiceTypeList = {Items: [], SelectedValue: this.state.voiceTypeSelectedValue};
      var voiceTypeObj = data.VoiceTypes.Items;
      for (var i = 0; i < voiceTypeObj.length; i++){
        voiceTypeList.Items.push({ value:voiceTypeObj[i].id , label:voiceTypeObj[i].label  });
      }

      //lyricist numberOfSongsWrittenRange new object
      var numberOfSongsWrittenRangeListLyricist = {Items: [], SelectedValue: this.state.lyricistNumberOfSongsWritten};
      var numberOfSongsWrittenRangeObj = data.NumberOfSongsWrittenRanges.Items;
      for (var i = 0; i < numberOfSongsWrittenRangeObj.length; i++){
        numberOfSongsWrittenRangeListLyricist.Items.push({ value:numberOfSongsWrittenRangeObj[i].id , label:numberOfSongsWrittenRangeObj[i].label  });
      }


      //lyricist UniversityDegree new object
      var universityDegreeListLyricist = {Items: [], SelectedValue: this.state.lyricistUniversityDegree};
      var universityDegreeObj = data.UniversityDegrees.Items;
      for (var i = 0; i < universityDegreeObj.length; i++){
        universityDegreeListLyricist.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
      }

      //translator numberOfTranslationsRange new object
      var numberOfTranslationsRangeListTranslator = {Items: [], SelectedValue: this.state.translatorNumberOfTranslations};
      var numberOfTranslationsRangeObj = data.NumberOfTranslationsRanges.Items;
      for (var i = 0; i < numberOfTranslationsRangeObj.length; i++){
        numberOfTranslationsRangeListTranslator.Items.push({ value:numberOfTranslationsRangeObj[i].id , label:numberOfTranslationsRangeObj[i].label  });
      }

      //translator UniversityDegree new object
      var universityDegreeListTranslator = {Items: [], SelectedValue: this.state.translatorUniversityDegree};
      var universityDegreeObj = data.UniversityDegrees.Items;
      for (var i = 0; i < universityDegreeObj.length; i++){
        universityDegreeListTranslator.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
      }

      //adaptor numberOfAdaptionsRange new object
      var numberOfAdaptionsRangeListAdaptor = {Items: [], SelectedValue: this.state.adaptorNumberOfAdaptionsRange};
      var numberOfAdaptionsRangeObj = data.NumberOfAdaptionsRanges.Items;
      for (var i = 0; i < numberOfAdaptionsRangeObj.length; i++){
        numberOfAdaptionsRangeListAdaptor.Items.push({ value:numberOfAdaptionsRangeObj[i].id , label:numberOfAdaptionsRangeObj[i].label  });
      }

      //adaptor UniversityDegree new object
      var universityDegreeListAdaptor = {Items: [], SelectedValue: this.state.adaptorUniversityDegree};
      var universityDegreeObj = data.UniversityDegrees.Items;
      for (var i = 0; i < universityDegreeObj.length; i++){
        universityDegreeListAdaptor.Items.push({ value:universityDegreeObj[i].id , label:universityDegreeObj[i].label  });
      }

      //languageAccent new object
      var languageAccentList = {Items: [], SelectedValue: this.state.languageAccent};
      if(data.LanguageAccents.Items.length>0){
        var languageAccentObj = data.LanguageAccents.Items;
        for (var i = 0; i < languageAccentObj.length; i++){
          languageAccentList.Items.push({ value:languageAccentObj[i].id , label:languageAccentObj[i].label  });
        }
        this.setState({languageAccent: true});
      }

      //voiceActorStudio
      var voiceActorStudio = {Items: [], SelectedValue: this.state.voiceActorStudio };
      //voiceActorClient
      var voiceActorClient = {Items: [], SelectedValue: this.state.voiceActorClient };
      //voiceActorSchool
      var voiceActorSchool = {Items: [], SelectedValue: this.state.voiceActorSchool };

      //productionCast
      var productionCast = {Items: [], SelectedValue: this.state.productionCast };
      //vacancyCast
      var vacancyCast = {Items: [], SelectedValue: this.state.vacancyCast };
      //externalExperienceCast
      var externalExperienceCast = {Items: [], SelectedValue: this.state.externalExperienceCast };

      //booker studio
      var bookerStudio = {Items: [], SelectedValue: this.state.bookerStudio };

      //singerStudio
      var singerStudio = {Items: [], SelectedValue: this.state.singerStudio };
      //singerClient
      var singerClient = {Items: [], SelectedValue: this.state.singerClient };
      //singerSchool
      var singerSchool = {Items: [], SelectedValue: this.state.singerSchool };

      //directorStudio
      var directorStudio = {Items: [], SelectedValue: this.state.directorStudio };
      //directorClient
      var directorClient = {Items: [], SelectedValue: this.state.directorClient };
      //directorSchool
      var directorSchool = {Items: [], SelectedValue: this.state.directorSchool };

      //lyricistStudio
      var lyricistStudio = {Items: [], SelectedValue: this.state.lyricistStudio };
      //lyricistClient
      var lyricistClient = {Items: [], SelectedValue: this.state.lyricistClient };

      //translatorStudio
      var translatorStudio = {Items: [], SelectedValue: this.state.translatorStudios };
      //translatorClient
      var translatorClient = {Items: [], SelectedValue: this.state.translatorClients };

      //editorStudio
      var editorStudio = {Items: [], SelectedValue: this.state.editorStudios };
      //editorClient
      var editorClient = {Items: [], SelectedValue: this.state.editorClients };
      //editorSchools
      var editorSchool = {Items: [], SelectedValue: this.state.editorSchools };

      //adaptorStudio
      var adaptorStudio = {Items: [], SelectedValue: this.state.adaptorStudios };
      //adaptorClient
      var adaptorClient = {Items: [], SelectedValue: this.state.adaptorClients };

      //soundEngineerStudio
      var soundEngineerStudio = {Items: [], SelectedValue: this.state.soundEngineerStudios };
      //soundEngineerClient
      var soundEngineerClient = {Items: [], SelectedValue: this.state.soundEngineerClients };
      //soundEngineerSchools
      var soundEngineerSchool = {Items: [], SelectedValue: this.state.soundEngineerSchools };


      //remoteRecording new object
      var remoteRecordingListVoiceActor = {Items: [], SelectedValue: this.state.remoteRecordingListVoiceActorSelectedValue};
      var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
      for (var i = 0; i < remoteRecordingObj.length; i++){
        remoteRecordingListVoiceActor.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
      }

      //remoteRecording new object
      var remoteRecordingEditor = {Items: [], SelectedValue: this.state.editorRemoteRecordingCapability};
      var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
      for (var i = 0; i < remoteRecordingObj.length; i++){
        remoteRecordingEditor.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
      }

      //remoteRecording new object
      var remoteRecordingDirector = {Items: [], SelectedValue: this.state.remoteRecordingDirectorSelectedValue};
      var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
      for (var i = 0; i < remoteRecordingObj.length; i++){
        remoteRecordingDirector.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
      }

      //director app access new object
      var directorAppAccess = {Items: [], SelectedValue: this.state.directorAppAccess};
      directorAppAccess.Items = [
        {value: 1, label: 'Enabled'},
        {value: 0, label: 'Disabled'}
      ]


      //remoteRecording new object
      var remoteRecordingListSoundEngineer = {Items: [], SelectedValue: this.state.soundEngineerRemoteRecordingCapability};
      var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
      for (var i = 0; i < remoteRecordingObj.length; i++){
        remoteRecordingListSoundEngineer.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
      }

      // singer VoiceAgeRange new object
      var voiceAgeRangeListSinger = {Items: [], SelectedValue: this.state.voiceAgeSingerSelectedValue};
      var voiceAgeRangeObj = data.VoiceAgeRanges.Items;
      for (var i = 0; i < voiceAgeRangeObj.length; i++){
        voiceAgeRangeListSinger.Items.push({ value:voiceAgeRangeObj[i].id , label:voiceAgeRangeObj[i].label  });
      }

      // singer vocalRangeSingerSelectedValue new object
      var vocalRangeListSinger = {Items: [], SelectedValue: this.state.vocalRangeSingerSelectedValue};
      var vocalRangeObj = data.VocalRanges.Items;
      for (var i = 0; i < vocalRangeObj.length; i++){
        vocalRangeListSinger.Items.push({ value:vocalRangeObj[i].id , label:vocalRangeObj[i].label  });
      }

      // singer readingMusicNoteSingerSelectedValue new object
      var readingMusicNoteListSinger = {Items: [], SelectedValue: this.state.readingMusicNoteSingerSelectedValue};
      var readingMusicNoteObj = data.MusicNotesReadingLevels.Items;
      for (var i = 0; i < readingMusicNoteObj.length; i++){
        readingMusicNoteListSinger.Items.push({ value:readingMusicNoteObj[i].id , label:readingMusicNoteObj[i].label  });
      }

      //lyricist remoteRecording new object
      var remoteRecordingListLyricist = {Items: [], SelectedValue: this.state.remoteRecordingLyricistSelectedValue};
      var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
      for (var i = 0; i < remoteRecordingObj.length; i++){
        remoteRecordingListLyricist.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
      }

      //singer remoteRecording new object
      var remoteRecordingListSinger = {Items: [], SelectedValue: this.state.remoteRecordingSingerSelectedValue};
      var remoteRecordingObj = data.RemoteRecordingCapabilities.Items;
      for (var i = 0; i < remoteRecordingObj.length; i++){
        remoteRecordingListSinger.Items.push({ value:remoteRecordingObj[i].id , label:remoteRecordingObj[i].label  });
      }

      //union new object
      var unionListVoiceActor = {Items: [], SelectedValue: this.state.voiceActorUnionSelectedValue};
      if(data.Unions.Items.length>0){
        var unionObj = data.Unions.Items;
        for (var i = 0; i < unionObj.length; i++){
          unionListVoiceActor.Items.push({ value:unionObj[i].id , label:unionObj[i].label  });
        }
        this.setState({isVoiceActorUnion: true});
      }

      //union new object
      var unionListSinger = {Items: [], SelectedValue: this.state.singerUnionSelectedValue};
      if(data.Unions.Items.length>0){
        var unionObj = data.Unions.Items;
        for (var i = 0; i < unionObj.length; i++){
          unionListSinger.Items.push({ value:unionObj[i].id , label:unionObj[i].label  });
        }
        this.setState({isSingerUnion: true});
      }





      this.props.setVacancyCriteriaDropdownOptions(
        skillLevelList,
        cityList,
        nativeLanguageList,
        nativeLanguageList,
        nativeLanguageList,
        nativeLanguageList,
        experienceList,
        nativeLanguageList,
        ageFromList,
        ageToList,
        nativeLanguageList,
        countryList,
        regionList,
        ethnicityList,
        identityList,
        voiceAgeRangeList,
        voiceTypeList,
        remoteRecordingListVoiceActor,
        remoteRecordingDirector,
        voiceActorStudio,
        voiceActorClient,
        voiceActorSchool,
        skillTypeList,
        productionCast,
        vacancyCast,
        externalExperienceCast,
        bookerStudio,
        voiceAgeRangeListSinger,
        vocalRangeListSinger,
        readingMusicNoteListSinger,
        singerStudio,
        singerClient,
        singerSchool,
        directorStudio,
        directorClient,
        directorSchool,
        numberOfSongsWrittenRangeListLyricist,
        universityDegreeListLyricist,
        lyricistStudio,
        lyricistClient,
        remoteRecordingListLyricist,
        numberOfTranslationsRangeListTranslator,
        universityDegreeListTranslator,
        translatorStudio,
        translatorClient,
        editorStudio,
        editorClient,
        editorSchool,
        remoteRecordingEditor,
        numberOfAdaptionsRangeListAdaptor,
        universityDegreeListAdaptor,
        adaptorStudio,
        adaptorClient,
        soundEngineerStudio,
        soundEngineerClient,
        soundEngineerSchool,
        remoteRecordingListSoundEngineer,
        directorAppAccess,
        remoteRecordingListSinger,
        languageAccentList,
        unionListVoiceActor,
        unionListSinger
      )

        this.setState({
          criteriaEnabled: this.state.candidatesMatchingEnabled
        })

        // think about
        this.setState({
          url: url
        })
    });
  }



  enableCriteria() {
    this.setState({
      criteriaEnabled: true
    })
  }

  getCriteriaComponent(){
    let profileType = this.props.overview.ProfileType;

    switch(profileType) {
      case PROFILE_TYPE_DIRECTOR:
        return (<DirectorCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
          // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
          setClick={click => this.saveCriteria = click} //click criteriaSave in child
          voiceActorStudio={this.state.voiceActorStudio}
          voiceActorClient={this.state.voiceActorClient}
          voiceActorSchool={this.state.voiceActorSchool}
          productionCast={this.state.productionCast}
          vacancyCast={this.state.vacancyCast}
          externalExperienceCast={this.state.externalExperienceCast}
          bookerStudio={this.state.bookerStudio}
          singerStudio={this.state.singerStudio}
          singerClient={this.state.singerClient}
          singerSchool={this.state.singerSchool}
          directorStudio={this.state.directorStudio}
          directorClient={this.state.directorClient}
          directorSchool={this.state.directorSchool}
          lyricistStudio={this.state.lyricistStudio}
          lyricistClient={this.state.lyricistClient}
          translatorStudio={this.state.translatorStudios}
          translatorClient={this.state.translatorClients}
          editorStudio={this.state.editorStudios}
          editorClient={this.state.editorClients}
          editorSchool={this.state.editorSchools}
          adaptorStudio={this.state.adaptorStudios}
          adaptorClient={this.state.adaptorClients}
          soundEngineerStudio={this.state.soundEngineerStudios}
          soundEngineerClient={this.state.soundEngineerClients}
          soundEngineerSchool={this.state.soundEngineerSchools}
          ethnicityExists={this.state.ethnicityExists}
          identityExists={this.state.identityExists}
          languageAccent={this.state.languageAccent}
          isVoiceActorUnion={this.state.isVoiceActorUnion}
          isSingerUnion={this.state.isSingerUnion}
          profileType={profileType}
          url={this.state.url}
          overview={this.props.overview}
        />);
      case PROFILE_TYPE_TRANSLATOR:
        return (<TranslatorCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
          // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
          setClick={click => this.saveCriteria = click} //click criteriaSave in child
          voiceActorStudio={this.state.voiceActorStudio}
          voiceActorClient={this.state.voiceActorClient}
          voiceActorSchool={this.state.voiceActorSchool}
          productionCast={this.state.productionCast}
          vacancyCast={this.state.vacancyCast}
          externalExperienceCast={this.state.externalExperienceCast}
          bookerStudio={this.state.bookerStudio}
          singerStudio={this.state.singerStudio}
          singerClient={this.state.singerClient}
          singerSchool={this.state.singerSchool}
          directorStudio={this.state.directorStudio}
          directorClient={this.state.directorClient}
          directorSchool={this.state.directorSchool}
          lyricistStudio={this.state.lyricistStudio}
          lyricistClient={this.state.lyricistClient}
          translatorStudio={this.state.translatorStudios}
          translatorClient={this.state.translatorClients}
          editorStudio={this.state.editorStudios}
          editorClient={this.state.editorClients}
          editorSchool={this.state.editorSchools}
          adaptorStudio={this.state.adaptorStudios}
          adaptorClient={this.state.adaptorClients}
          soundEngineerStudio={this.state.soundEngineerStudios}
          soundEngineerClient={this.state.soundEngineerClients}
          soundEngineerSchool={this.state.soundEngineerSchools}
          ethnicityExists={this.state.ethnicityExists}
          identityExists={this.state.identityExists}
          languageAccent={this.state.languageAccent}
          isVoiceActorUnion={this.state.isVoiceActorUnion}
          isSingerUnion={this.state.isSingerUnion}
          profileType={profileType}
          url={this.state.url}
          overview={this.props.overview}
          />);
       case PROFILE_TYPE_VOICEACTOR:
           return (<VoiceActorCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
             // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
             setClick={click => this.saveCriteria = click} //click criteriaSave in child
             voiceActorStudio={this.state.voiceActorStudio}
             voiceActorClient={this.state.voiceActorClient}
             voiceActorSchool={this.state.voiceActorSchool}
             productionCast={this.state.productionCast}
             vacancyCast={this.state.vacancyCast}
             externalExperienceCast={this.state.externalExperienceCast}
             bookerStudio={this.state.bookerStudio}
             singerStudio={this.state.singerStudio}
             singerClient={this.state.singerClient}
             singerSchool={this.state.singerSchool}
             directorStudio={this.state.directorStudio}
             directorClient={this.state.directorClient}
             directorSchool={this.state.directorSchool}
             lyricistStudio={this.state.lyricistStudio}
             lyricistClient={this.state.lyricistClient}
             translatorStudio={this.state.translatorStudios}
             translatorClient={this.state.translatorClients}
             editorStudio={this.state.editorStudios}
             editorClient={this.state.editorClients}
             editorSchool={this.state.editorSchools}
             adaptorStudio={this.state.adaptorStudios}
             adaptorClient={this.state.adaptorClients}
             soundEngineerStudio={this.state.soundEngineerStudios}
             soundEngineerClient={this.state.soundEngineerClients}
             soundEngineerSchool={this.state.soundEngineerSchools}
             ethnicityExists={this.state.ethnicityExists}
             identityExists={this.state.identityExists}
             languageAccent={this.state.languageAccent}
             isVoiceActorUnion={this.state.isVoiceActorUnion}
             isSingerUnion={this.state.isSingerUnion}
             profileType={profileType}
             url={this.state.url}
             overview={this.props.overview}
             />);
       case PROFILE_TYPE_SINGER:
           return (<SingerCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
             // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
             setClick={click => this.saveCriteria = click} //click criteriaSave in child
             voiceActorStudio={this.state.voiceActorStudio}
             voiceActorClient={this.state.voiceActorClient}
             voiceActorSchool={this.state.voiceActorSchool}
             productionCast={this.state.productionCast}
             vacancyCast={this.state.vacancyCast}
             externalExperienceCast={this.state.externalExperienceCast}
             bookerStudio={this.state.bookerStudio}
             singerStudio={this.state.singerStudio}
             singerClient={this.state.singerClient}
             singerSchool={this.state.singerSchool}
             directorStudio={this.state.directorStudio}
             directorClient={this.state.directorClient}
             directorSchool={this.state.directorSchool}
             lyricistStudio={this.state.lyricistStudio}
             lyricistClient={this.state.lyricistClient}
             translatorStudio={this.state.translatorStudios}
             translatorClient={this.state.translatorClients}
             editorStudio={this.state.editorStudios}
             editorClient={this.state.editorClients}
             editorSchool={this.state.editorSchools}
             adaptorStudio={this.state.adaptorStudios}
             adaptorClient={this.state.adaptorClients}
             soundEngineerStudio={this.state.soundEngineerStudios}
             soundEngineerClient={this.state.soundEngineerClients}
             soundEngineerSchool={this.state.soundEngineerSchools}
             ethnicityExists={this.state.ethnicityExists}
             identityExists={this.state.identityExists}
             languageAccent={this.state.languageAccent}
             isVoiceActorUnion={this.state.isVoiceActorUnion}
             isSingerUnion={this.state.isSingerUnion}
             profileType={profileType}
             url={this.state.url}
             overview={this.props.overview}
             />);
       case PROFILE_TYPE_ADAPTOR:
           return (<AdaptorCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
             // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
             setClick={click => this.saveCriteria = click} //click criteriaSave in child
             voiceActorStudio={this.state.voiceActorStudio}
             voiceActorClient={this.state.voiceActorClient}
             voiceActorSchool={this.state.voiceActorSchool}
             productionCast={this.state.productionCast}
             vacancyCast={this.state.vacancyCast}
             externalExperienceCast={this.state.externalExperienceCast}
             bookerStudio={this.state.bookerStudio}
             singerStudio={this.state.singerStudio}
             singerClient={this.state.singerClient}
             singerSchool={this.state.singerSchool}
             directorStudio={this.state.directorStudio}
             directorClient={this.state.directorClient}
             directorSchool={this.state.directorSchool}
             lyricistStudio={this.state.lyricistStudio}
             lyricistClient={this.state.lyricistClient}
             translatorStudio={this.state.translatorStudios}
             translatorClient={this.state.translatorClients}
             editorStudio={this.state.editorStudios}
             editorClient={this.state.editorClients}
             editorSchool={this.state.editorSchools}
             adaptorStudio={this.state.adaptorStudios}
             adaptorClient={this.state.adaptorClients}
             soundEngineerStudio={this.state.soundEngineerStudios}
             soundEngineerClient={this.state.soundEngineerClients}
             soundEngineerSchool={this.state.soundEngineerSchools}
             ethnicityExists={this.state.ethnicityExists}
             identityExists={this.state.identityExists}
             languageAccent={this.state.languageAccent}
             isVoiceActorUnion={this.state.isVoiceActorUnion}
             isSingerUnion={this.state.isSingerUnion}
             profileType={profileType}
             url={this.state.url}
             overview={this.props.overview}
             />);
       case PROFILE_TYPE_LYRICIST:
           return (<LyricistCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
             // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
             setClick={click => this.saveCriteria = click} //click criteriaSave in child
             voiceActorStudio={this.state.voiceActorStudio}
             voiceActorClient={this.state.voiceActorClient}
             voiceActorSchool={this.state.voiceActorSchool}
             productionCast={this.state.productionCast}
             vacancyCast={this.state.vacancyCast}
             externalExperienceCast={this.state.externalExperienceCast}
             bookerStudio={this.state.bookerStudio}
             singerStudio={this.state.singerStudio}
             singerClient={this.state.singerClient}
             singerSchool={this.state.singerSchool}
             directorStudio={this.state.directorStudio}
             directorClient={this.state.directorClient}
             directorSchool={this.state.directorSchool}
             lyricistStudio={this.state.lyricistStudio}
             lyricistClient={this.state.lyricistClient}
             translatorStudio={this.state.translatorStudios}
             translatorClient={this.state.translatorClients}
             editorStudio={this.state.editorStudios}
             editorClient={this.state.editorClients}
             editorSchool={this.state.editorSchools}
             adaptorStudio={this.state.adaptorStudios}
             adaptorClient={this.state.adaptorClients}
             soundEngineerStudio={this.state.soundEngineerStudios}
             soundEngineerClient={this.state.soundEngineerClients}
             soundEngineerSchool={this.state.soundEngineerSchools}
             ethnicityExists={this.state.ethnicityExists}
             identityExists={this.state.identityExists}
             languageAccent={this.state.languageAccent}
             isVoiceActorUnion={this.state.isVoiceActorUnion}
             isSingerUnion={this.state.isSingerUnion}
             profileType={profileType}
             url={this.state.url}
             overview={this.props.overview}
             />);
       case PROFILE_TYPE_EDITOR:
           return (<EditorCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
             // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
             setClick={click => this.saveCriteria = click} //click criteriaSave in child
             voiceActorStudio={this.state.voiceActorStudio}
             voiceActorClient={this.state.voiceActorClient}
             voiceActorSchool={this.state.voiceActorSchool}
             productionCast={this.state.productionCast}
             vacancyCast={this.state.vacancyCast}
             externalExperienceCast={this.state.externalExperienceCast}
             bookerStudio={this.state.bookerStudio}
             singerStudio={this.state.singerStudio}
             singerClient={this.state.singerClient}
             singerSchool={this.state.singerSchool}
             directorStudio={this.state.directorStudio}
             directorClient={this.state.directorClient}
             directorSchool={this.state.directorSchool}
             lyricistStudio={this.state.lyricistStudio}
             lyricistClient={this.state.lyricistClient}
             translatorStudio={this.state.translatorStudios}
             translatorClient={this.state.translatorClients}
             editorStudio={this.state.editorStudios}
             editorClient={this.state.editorClients}
             editorSchool={this.state.editorSchools}
             adaptorStudio={this.state.adaptorStudios}
             adaptorClient={this.state.adaptorClients}
             soundEngineerStudio={this.state.soundEngineerStudios}
             soundEngineerClient={this.state.soundEngineerClients}
             soundEngineerSchool={this.state.soundEngineerSchools}
             ethnicityExists={this.state.ethnicityExists}
             identityExists={this.state.identityExists}
             languageAccent={this.state.languageAccent}
             isVoiceActorUnion={this.state.isVoiceActorUnion}
             isSingerUnion={this.state.isSingerUnion}
             profileType={profileType}
             url={this.state.url}
             overview={this.props.overview}
             />);
       case PROFILE_TYPE_SOUNDENGINEER:
           return (<SoundEngineerCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
             // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
             setClick={click => this.saveCriteria = click} //click criteriaSave in child
             voiceActorStudio={this.state.voiceActorStudio}
             voiceActorClient={this.state.voiceActorClient}
             voiceActorSchool={this.state.voiceActorSchool}
             productionCast={this.state.productionCast}
             vacancyCast={this.state.vacancyCast}
             externalExperienceCast={this.state.externalExperienceCast}
             bookerStudio={this.state.bookerStudio}
             singerStudio={this.state.singerStudio}
             singerClient={this.state.singerClient}
             singerSchool={this.state.singerSchool}
             directorStudio={this.state.directorStudio}
             directorClient={this.state.directorClient}
             directorSchool={this.state.directorSchool}
             lyricistStudio={this.state.lyricistStudio}
             lyricistClient={this.state.lyricistClient}
             translatorStudio={this.state.translatorStudios}
             translatorClient={this.state.translatorClients}
             editorStudio={this.state.editorStudios}
             editorClient={this.state.editorClients}
             editorSchool={this.state.editorSchools}
             adaptorStudio={this.state.adaptorStudios}
             adaptorClient={this.state.adaptorClients}
             soundEngineerStudio={this.state.soundEngineerStudios}
             soundEngineerClient={this.state.soundEngineerClients}
             soundEngineerSchool={this.state.soundEngineerSchools}
             ethnicityExists={this.state.ethnicityExists}
             identityExists={this.state.identityExists}
             languageAccent={this.state.languageAccent}
             isVoiceActorUnion={this.state.isVoiceActorUnion}
             isSingerUnion={this.state.isSingerUnion}
             profileType={profileType}
             url={this.state.url}
             overview={this.props.overview}
             />);
       case PROFILE_TYPE_BOOKER:
           return (<BookerCriteria vacancyId={this.props.vacancyId} onCriteriaSearch={this.onCriteriaSearch}
             // setCriteriaData={this.setCriteriaData.bind(this)}//check if criteria data exist and set state and show/hide buton
             setClick={click => this.saveCriteria = click} //click criteriaSave in child
             voiceActorStudio={this.state.voiceActorStudio}
             voiceActorClient={this.state.voiceActorClient}
             voiceActorSchool={this.state.voiceActorSchool}
             productionCast={this.state.productionCast}
             vacancyCast={this.state.vacancyCast}
             externalExperienceCast={this.state.externalExperienceCast}
             bookerStudio={this.state.bookerStudio}
             singerStudio={this.state.singerStudio}
             singerClient={this.state.singerClient}
             singerSchool={this.state.singerSchool}
             directorStudio={this.state.directorStudio}
             directorClient={this.state.directorClient}
             directorSchool={this.state.directorSchool}
             lyricistStudio={this.state.lyricistStudio}
             lyricistClient={this.state.lyricistClient}
             translatorStudio={this.state.translatorStudios}
             translatorClient={this.state.translatorClients}
             editorStudio={this.state.editorStudios}
             editorClient={this.state.editorClients}
             editorSchool={this.state.editorSchools}
             adaptorStudio={this.state.adaptorStudios}
             adaptorClient={this.state.adaptorClients}
             soundEngineerStudio={this.state.soundEngineerStudios}
             soundEngineerClient={this.state.soundEngineerClients}
             soundEngineerSchool={this.state.soundEngineerSchools}
             ethnicityExists={this.state.ethnicityExists}
             identityExists={this.state.identityExists}
             languageAccent={this.state.languageAccent}
             isVoiceActorUnion={this.state.isVoiceActorUnion}
             isSingerUnion={this.state.isSingerUnion}
             profileType={profileType}
             url={this.state.url}
             overview={this.props.overview}
             />);
      default:
        return (<div />);
    }
  }

  setCriteriaData(value){
    this.setState({isCriteriaDataSet:value});
  }

  render() {

  //call setVacancyCriteriaCheckboxValue here cause states are now visabled
  this.props.setVacancyCriteriaCheckboxValue(
    this.state.knownTalentSelectedValue,
    this.state.doNotUseSelectedValue,
    this.state.skillVendorStatusSelectedValue,
    this.state.liveActionVoiceGenderMale,
    this.state.liveActionVoiceGenderFemale,
    this.state.voiceActorTheatricalExperience,
    this.state.voiceActorTVExperience,
    this.state.voiceActorVideoGamesExperience,
    this.state.voiceActorPromoOrCommercialsExperience,
    this.state.voiceActorAnimationMaleVoiceGender,
    this.state.voiceActorAnimationFemaleVoiceGender,
    this.state.voiceActorLiveActionExperience,
    this.state.voiceActorAnimationExperience,
    this.state.voiceActorDubbingExperience,
    this.state.voiceActorAudiobooksExperience,
    this.state.voiceActorVoiceOverExperience,
    this.state.voiceActorRadioExperience,
    this.state.voiceActorTheatreActorExperience,
    this.state.voiceActorMovieActorExperience,
    this.state.voiceActorAudioDescriptionExperience,
    this.state.bookerTheatricalExperience,
    this.state.bookerTVExperience,
    this.state.bookerInteractiveExperience,
    this.state.singerMaleVoiceGender,
    this.state.singerFemaleVoiceGender,
    this.state.singerDubbingExperience,
    this.state.singerStageExperience,
    this.state.singerTheatreExperience,
    this.state.singerTalentShowExperience,
    this.state.directorTheatricalExperience,
    this.state.directorTVExperience,
    this.state.directorGamesExperience,
    this.state.directorPromoOrCommercialsExperience,
    this.state.directorLiveActionExperience,
    this.state.directorAnimationExperience,
    this.state.directorDubbingDirectorExperience,
    this.state.directorVoiceOverDirectorExperience,
    this.state.directorSongDirectorExperience,
    this.state.directorDubbingActorExperience,
    this.state.directorStageDirectorExperience,
    this.state.directorMovieDirectorExperience,
    this.state.directorAudioDescriptionExperience,
    this.state.lyricistMusicalExperience,
    this.state.lyricistTheatreExperience,
    this.state.lyricistPromoCommercialsExperience,
    this.state.lyricistExperience,
    this.state.lyricistDubbingExperience,
    this.state.lyricistMusicianExperience,
    this.state.translatorTheatricalExperience,
    this.state.translatorTVExperience,
    this.state.translatorGamesExperience,
    this.state.translatorPromoOrCommercialsExperience,
    this.state.translatorLiveActionExperience,
    this.state.translatorAnimationExperience,
    this.state.translatorSubtitlesExperience,
    this.state.translatorDubbingExperience,
    this.state.translatorVoiceOverExperience,
    this.state.translatorGamingExperience,
    this.state.translatorAudioDescriptionExperience,
    this.state.translatorHOHSDHCCExperience,
    this.state.editorDubbingExperience,
    this.state.editorVoiceOverExperience,
    this.state.editorSongsExperience,
    this.state.editorProToolsExperience,
    this.state.editorDolby51Experience,
    this.state.editorAtmosExperience,
    this.state.editorFoleyExperience,
    this.state.editorRecordingEditingExperience,
    this.state.editorDialogueEditingExperience,
    this.state.editorMusicAndEffectsExperience,
    this.state.editorMixEditingExperience,
    this.state.editorPreparingTakesExperience,
    this.state.editorAudioDescriptionExperience,
    this.state.adaptorTheatricalExperience,
    this.state.adaptorTVExperience,
    this.state.adaptorGamesExperience,
    this.state.adaptorPromoOrCommercialsExperience,
    this.state.adaptorLiveActionExperience,
    this.state.adaptorAnimationExperience,
    this.state.adaptorAdaptorExperience,
    this.state.adaptorDubbingDirectorExperience,
    this.state.adaptorTranslatorExperience,
    this.state.adaptorVoiceActorExperience,
    this.state.adaptorAudioDescriptionExperience,
    this.state.soundEngineerDubbingExperience,
    this.state.soundEngineerVoiceOverExperience,
    this.state.soundEngineerSongsExperience,
    this.state.soundEngineerProToolsExperience,
    this.state.soundEngineerDolby51Experience,
    this.state.soundEngineerAtmosExperience,
    this.state.soundEngineerFoleyExperience,
    this.state.soundEngineerDialogueRecordingExperience,
    this.state.soundEngineerSongRecordingExperience,
    this.state.soundEngineerDialogueMixingExperience,
    this.state.soundEngineerSongMixingExperience,
    this.state.soundEngineerAudioDescriptionMixingExperience,
    this.state.singerGenderNeutralVoice,
    this.state.voiceActorGenderNeutralVoice,
    this.state.adaptorDoNotUse,
    this.state.bookerDoNotUse,
    this.state.directorDoNotUse,
    this.state.editorDoNotUse,
    this.state.singerDoNotUse,
    this.state.lyricistDoNotUse,
    this.state.soundEngineerDoNotUse,
    this.state.translatorDoNotUse,
    this.state.voiceActorDoNotUse
  );

    if (this.props.overview === null) {
      return (<div />)
    }
    let criteriaComponent = this.getCriteriaComponent();

    return (
      <div>
        {this.state.criteriaEnabled === false &&
          <div>
            <Alert className="alert alert-info alert-outline">
              The criteria are not in use.
            </Alert>
            <ProtectedElement permission={PERMISSION_VACANCIES_CRITERIA_WRITE}>
              <button id="Save" type="button" className="btn btn-rounded btn-primary" onClick={this.enableCriteria}>Enable criteria</button>
            </ProtectedElement>
          </div>
        }

        {this.state.criteriaEnabled === true &&
          (<div>
            {criteriaComponent}
          </div>)
        }


      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  overview: state.vacancyPage.overview
})
const mapDispatchToProps = dispatch => ({
  setVacancyCriteriaDropdownOptions(skillLevels, cities, voiceGenders, liveActionVoiceGenders, animationVoiceGenders, nativeLanguages, languages,
    productionContentOwners, ageFromList, ageToList, productionExperienceList,
     countryList, regionList, ethnicityList, identityList, voiceAgeRangeList, voiceTypeList, remoteRecordingListVoiceActor, remoteRecordingDirector, voiceActorStudio,
   voiceActorClient, voiceActorSchool, skillTypes, productionCast, vacancyCast,externalExperienceCast, bookerStudio, voiceAgeRangeListSinger,
 vocalRangeListSinger, readingMusicNoteListSinger, singerStudio,singerClient, singerSchool, directorStudio, directorClient, direcotoSchool, numberOfSongsWrittenRangeListLyricist,
universityDegreeListLyricist, lyricistStudio, lyricistClient,remoteRecordingListLyricist, numberOfTranslationsRangeListTranslator, universityDegreeListTranslator,
translatorStudio, translatorClient, editorStudio, editorClient, editorSchool, remoteRecordingEditor, numberOfAdaptionsRangeListAdaptor, universityDegreeListAdaptor,
adaptorStudio, adaptorClient, soundEngineerStudio, soundEngineerClient, soundEngineerSchool, remoteRecordingListSoundEngineer,directorAppAccess, remoteRecordingListSinger,
languageAccentList, unionListVoiceActor, unionListSinger) {
    dispatch(setVacancyCriteriaDropdownOptions(skillLevels, cities, voiceGenders, liveActionVoiceGenders, animationVoiceGenders, nativeLanguages, languages,
      productionContentOwners, ageFromList, ageToList, productionExperienceList,
      countryList, regionList, ethnicityList, identityList, voiceAgeRangeList, voiceTypeList, remoteRecordingListVoiceActor, remoteRecordingDirector, voiceActorStudio,
    voiceActorClient, voiceActorSchool, skillTypes, productionCast, vacancyCast,externalExperienceCast, bookerStudio, voiceAgeRangeListSinger,
  vocalRangeListSinger, readingMusicNoteListSinger, singerStudio,singerClient, singerSchool, directorStudio, directorClient, direcotoSchool, numberOfSongsWrittenRangeListLyricist,
universityDegreeListLyricist, lyricistStudio, lyricistClient, remoteRecordingListLyricist, numberOfTranslationsRangeListTranslator, universityDegreeListTranslator,
translatorStudio, translatorClient, editorStudio, editorClient, editorSchool, remoteRecordingEditor, numberOfAdaptionsRangeListAdaptor, universityDegreeListAdaptor,
adaptorStudio, adaptorClient, soundEngineerStudio, soundEngineerClient, soundEngineerSchool, remoteRecordingListSoundEngineer, directorAppAccess, remoteRecordingListSinger,
languageAccentList, unionListVoiceActor, unionListSinger))
  },
  setVacancyCriteriaCheckboxValue(knownTalent, doNotUse, skillVendorStatus, liveActionVoiceGenderMale, liveActionVoiceGenderFemale, voiceActorTheatricalExperience,
  voiceActorTVExperience, voiceActorVideoGamesExperience,voiceActorPromoOrCommercialsExperience, voiceActorAnimationMaleVoiceGender,voiceActorAnimationFemaleVoiceGender,
voiceActorLiveActionExperience, voiceActorAnimationExperience,voiceActorDubbingExperience,voiceActorAudiobooksExperience, voiceActorVoiceOverExperience,
voiceActorRadioExperience,voiceActorTheatreActorExperience,voiceActorMovieActorExperience,voiceActorAudioDescriptionExperience, bookerTheatricalExperience,
bookerTVExperience, bookerInteractiveExperience, singerMaleVoiceGender, singerFemaleVoiceGender, singerDubbingExperience,singerStageExperience,singerTheatreExperience,
singerTalentShowExperience, directorTheatricalExperience, directorTVExperience, directorGamesExperience, directorPromoOrCommercialsExperience,
directorLiveActionExperience, directorAnimationExperience, directorDubbingDirectorExperience, directorVoiceOverDirectorExperience, directorSongDirectorExperience,
directorDubbingActorExperience, directorStageDirectorExperience, directorMovieDirectorExperience, directorAudioDescriptionExperience, lyricistMusicalExperience,
lyricistTheatreExperience, lyricistPromoCommercialsExperience, lyricistExperience, lyricistDubbingExperience, lyricistMusicianExperience,
translatorTheatricalExperience, translatorTVExperience, translatorGamesExperience, translatorPromoOrCommercialsExperience, translatorLiveActionExperience,
translatorAnimationExperience, translatorSubtitlesExperience, translatorDubbingExperience, translatorVoiceOverExperience, translatorGamingExperience,
translatorAudioDescriptionExperience,translatorHOHSDHCCExperience, editorDubbingExperience, editorVoiceOverExperience, editorSongsExperience, editorProToolsExperience,
editorDolby51Experience, editorAtmosExperience, editorFoleyExperience, editorRecordingEditingExperience, editorDialogueEditingExperience, editorMusicAndEffectsExperience,
editorMixEditingExperience, editorPreparingTakesExperience, editorAudioDescriptionExperience, adaptorTheatricalExperience,adaptorTVExperience, adaptorGamesExperience,
adaptorPromoOrCommercialsExperience, adaptorLiveActionExperience, adaptorAnimationExperience, adaptorAdaptorExperience, adaptorDubbingDirectorExperience,
adaptorTranslatorExperience, adaptorVoiceActorExperience, adaptorAudioDescriptionExperience, soundEngineerDubbingExperience, soundEngineerVoiceOverExperience,
soundEngineerSongsExperience, soundEngineerProToolsExperience,soundEngineerDolby51Experience,soundEngineerAtmosExperience,soundEngineerFoleyExperience,
soundEngineerDialogueRecordingExperience,soundEngineerSongRecordingExperience,soundEngineerDialogueMixingExperience,soundEngineerSongMixingExperience,
soundEngineerAudioDescriptionMixingExperience,singerGenderNeutralVoice, voiceActorGenderNeutralVoice, adaptorDoNotUse, bookerDoNotUse, directorDoNotUse, editorDoNotUse, lyricistDoNotUse, singerDoNotUse,
soundEngineerDoNotUse, translatorDoNotUse, voiceActorDoNotUse)
  {dispatch(setVacancyCriteriaCheckboxValue(knownTalent, doNotUse, skillVendorStatus, liveActionVoiceGenderMale, liveActionVoiceGenderFemale, voiceActorTheatricalExperience,
  voiceActorTVExperience, voiceActorVideoGamesExperience,voiceActorPromoOrCommercialsExperience,voiceActorAnimationMaleVoiceGender,voiceActorAnimationFemaleVoiceGender,
voiceActorLiveActionExperience,voiceActorAnimationExperience,voiceActorDubbingExperience,voiceActorAudiobooksExperience, voiceActorVoiceOverExperience,
voiceActorRadioExperience,voiceActorTheatreActorExperience,voiceActorMovieActorExperience,voiceActorAudioDescriptionExperience, bookerTheatricalExperience,
bookerTVExperience, bookerInteractiveExperience, singerMaleVoiceGender, singerFemaleVoiceGender, singerDubbingExperience,singerStageExperience,singerTheatreExperience,
singerTalentShowExperience, directorTheatricalExperience, directorTVExperience, directorGamesExperience, directorPromoOrCommercialsExperience,
directorLiveActionExperience, directorAnimationExperience, directorDubbingDirectorExperience, directorVoiceOverDirectorExperience, directorSongDirectorExperience,
directorDubbingActorExperience, directorStageDirectorExperience, directorMovieDirectorExperience, directorAudioDescriptionExperience, lyricistMusicalExperience,
lyricistTheatreExperience, lyricistPromoCommercialsExperience, lyricistExperience, lyricistDubbingExperience, lyricistMusicianExperience,
translatorTheatricalExperience, translatorTVExperience, translatorGamesExperience, translatorPromoOrCommercialsExperience, translatorLiveActionExperience,
translatorAnimationExperience, translatorSubtitlesExperience, translatorDubbingExperience, translatorVoiceOverExperience, translatorGamingExperience,
translatorAudioDescriptionExperience,translatorHOHSDHCCExperience, editorDubbingExperience, editorVoiceOverExperience, editorSongsExperience, editorProToolsExperience,
editorDolby51Experience, editorAtmosExperience, editorFoleyExperience, editorRecordingEditingExperience, editorDialogueEditingExperience, editorMusicAndEffectsExperience,
editorMixEditingExperience, editorPreparingTakesExperience, editorAudioDescriptionExperience, adaptorTheatricalExperience,adaptorTVExperience, adaptorGamesExperience,
adaptorPromoOrCommercialsExperience, adaptorLiveActionExperience, adaptorAnimationExperience, adaptorAdaptorExperience, adaptorDubbingDirectorExperience,
adaptorTranslatorExperience, adaptorVoiceActorExperience, adaptorAudioDescriptionExperience,soundEngineerDubbingExperience, soundEngineerVoiceOverExperience,
soundEngineerSongsExperience, soundEngineerProToolsExperience,soundEngineerDolby51Experience,soundEngineerAtmosExperience,soundEngineerFoleyExperience,
soundEngineerDialogueRecordingExperience,soundEngineerSongRecordingExperience,soundEngineerDialogueMixingExperience,soundEngineerSongMixingExperience,
soundEngineerAudioDescriptionMixingExperience,singerGenderNeutralVoice,voiceActorGenderNeutralVoice, adaptorDoNotUse, bookerDoNotUse, directorDoNotUse, editorDoNotUse, lyricistDoNotUse, singerDoNotUse,
soundEngineerDoNotUse, translatorDoNotUse, voiceActorDoNotUse))},
  fetchVacancySkillVendorsByCriteriaSuccess(skillVendorsByCriteria) { dispatch(fetchVacancySkillVendorsByCriteriaSuccess(skillVendorsByCriteria)) },
  clearVacancySkillVendorsByCriteria() { dispatch(clearVacancySkillVendorsByCriteria()) },
  clearVacancyCandidates() { dispatch(clearVacancyCandidates()) }
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(Criteria)
